import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_FoodTechnology = () => {
  const [data, setData] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.foodTechnology, setData);
  }, [currentDomain]);

  // Function to render rich text content
  const renderContent = (content) => {
    if (!content || !Array.isArray(content)) return null;

    return content.map((block, index) => {
      switch (block.type) {
        case "heading":
          const HeadingTag = `h${block.level}`;
          return (
            <HeadingTag key={index} style={{ marginTop: "20px", marginBottom: "10px", fontWeight: "600", color: "#007bff" }}>
              {block.children?.map((child, childIndex) => (
                <span key={childIndex}>{child.text}</span>
              ))}
            </HeadingTag>
          );

        case "paragraph":
          return (
            <p key={index} style={{ marginBottom: "15px", lineHeight: "1.8" }}>
              {block.children?.map((child, childIndex) => (
                <span
                  key={childIndex}
                  style={{
                    fontWeight: child.bold ? "bold" : "normal",
                    fontStyle: child.italic ? "italic" : "normal",
                  }}
                >
                  {child.text}
                </span>
              ))}
            </p>
          );

        case "list":
          const ListTag = block.format === "ordered" ? "ol" : "ul";
          return (
            <ListTag key={index} style={{ marginBottom: "15px", paddingLeft: "30px", lineHeight: "1.8" }}>
              {block.children?.map((item, itemIndex) => (
                <li key={itemIndex} style={{ marginBottom: "8px" }}>
                  {item.children?.map((child, childIndex) => (
                    <span
                      key={childIndex}
                      style={{
                        fontWeight: child.bold ? "bold" : "normal",
                        fontStyle: child.italic ? "italic" : "normal",
                      }}
                    >
                      {child.text}
                    </span>
                  ))}
                </li>
              ))}
            </ListTag>
          );

        default:
          return null;
      }
    });
  };

  const sections = data?.data?.attributes?.sections || [];

  return (
    <React.Fragment>
      <Helmet>
        <title>Food Technology | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Food Technology Department at Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Food Technology, Department, OTPRI, JNTUA, Anantapur"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .content-section {
                        background: #fff;
                        border-radius: 8px;
                        padding: 30px;
                        box-shadow: 0 2px 10px rgba(0,123,255,0.1);
                        margin-bottom: 30px;
                    }

                    .section-title {
                        color: #007bff;
                        font-size: calc(${fontSize}px + 6px);
                        font-weight: 700;
                        margin-bottom: 20px;
                        padding-bottom: 15px;
                        border-bottom: 3px solid #007bff;
                        text-transform: uppercase;
                    }

                    .content-section h6 {
                        color: #0056b3;
                        font-size: calc(${fontSize}px + 2px);
                        font-weight: 600;
                        margin-top: 20px;
                        margin-bottom: 10px;
                    }

                    .content-section p {
                        line-height: 1.8;
                        margin-bottom: 15px;
                        color: #333;
                        text-align: justify;
                    }

                    .content-section ul {
                        margin-bottom: 15px;
                        padding-left: 30px;
                        line-height: 1.8;
                    }

                    .content-section ul li {
                        margin-bottom: 8px;
                        color: #333;
                        text-align: justify;
                    }

                    .content-section ol {
                        margin-bottom: 15px;
                        padding-left: 30px;
                        line-height: 1.8;
                    }

                    .content-section ol li {
                        margin-bottom: 8px;
                        color: #333;
                        text-align: justify;
                    }

                    .no-data-message {
                        text-align: center;
                        padding: 60px 20px;
                        color: #999;
                    }

                    .no-data-message i {
                        font-size: 60px;
                        color: #ddd;
                        margin-bottom: 20px;
                        display: block;
                    }

                    .no-data-message h5 {
                        color: #666;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    @media (max-width: 768px) {
                        .content-section {
                            padding: 20px;
                        }

                        .section-title {
                            font-size: calc(${fontSize}px + 4px);
                        }
                    }
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Food Technology"
          pageName="Food Technology"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title text-center mb-5">
                      Food Technology Department
                    </h3>

                    {sections.length > 0 ? (
                      sections.map((section, index) => (
                        <div key={index} className="content-section">
                          {section.title && (
                            <h4 className="section-title">{section.title}</h4>
                          )}
                          <div className="section-content">
                            {renderContent(section.content)}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="content-section">
                        <div className="no-data-message">
                          <i className="fas fa-utensils"></i>
                          <h5>No content available at the moment.</h5>
                          <p>Please check back later for Food Technology department information.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_FoodTechnology;
